export default "/assets/images/filter-CC.9604eecaaa4463d3.png";